
(function() {
    document.querySelectorAll('.errors__close').forEach(function(button) {
        button.addEventListener('click', function() {
            let parent = button.closest('.product__form__errors');
            if (parent) {
                parent.classList.remove('is-visible');
            }
        });
    });
})();
